import { useNavigate } from "react-router-dom";
import AlertIcon from "../../icons/AlertIcon";
import UserIcon from "../../icons/UserIcon";
import classes from "./SideBar.module.css";
import { useEffect, useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import Cookies from 'js-cookie';
import WalletIcon from "../../icons/WalletIcon";
import CoinsIcon from "../../icons/CoinsIcon";
import { useAuth } from "../../context/AuthContext";
import SparklesIcon from "../../icons/SparklesIcon";

const navList = [
  {
    icon: <UserIcon />,
    activeIcon: <UserIcon active={true} />,
    name: "Users",
    link: "users",
  },
  {
    icon: <WalletIcon />,
    activeIcon: <WalletIcon active={true} />,
    name: "Financial",
    link: "financial",
  },
  {
    icon: <AlertIcon />,
    activeIcon: <AlertIcon active={true} />,
    name: "Risk",
    link: "risk",
  },
  {
    icon: <CoinsIcon />,
    activeIcon: <CoinsIcon active={true} />,
    name: "Pool",
    link: "pool"
  }
  ,
  {
    icon: <SparklesIcon />,
    activeIcon: <SparklesIcon active={true} />,
    name: "Referrals",
    link: "referrals"
  }
];

const subNav = [
  {
    name: "Profile",
    link: "profile",
  },
  {
    name: "Theme",
    link: "theme",
  },
  {
    name: "Log out",
    link: "login",
  }
]

const NavContainer = ({ icon, title, active, onClick, onMouseEnter, onMouseLeave }) => {
  
  return (
    <div
      className={`d-flex align-items-center gap-2 ${classes.navContainer} ${active ? classes.tabActive : ""}`}
      onClick={onClick}
      role="button"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
        {icon}
      <h4>{title}</h4>
    </div>
  );
};

const SideBar = () => {
  const [showCardNav, setShowCardNav] = useState(false);
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate();
  const {darkMode, setDarkMode} = useTheme()

  const { user, logout } = useAuth();

  // Toggles between dark and light modes
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
      Cookies.set('theme', 'dark');
    } else {
      document.body.classList.remove('dark-mode');
      Cookies.set('theme', 'light');
    }
  }, [darkMode]);
  return (
    <div
      className={`d-flex flex-column align-items-center justify-content-between ${classes.wrapper}`}
    >
      <div>
        <div className="mb-5">
          <img src={`/PROPTRADING.FUN.svg`} />
          {/* <div className={classes.teamLabelContainer}>
            TEAM
          </div> */}
        </div>
        <div>
          {navList.map((item, i) => (
            <div className={classes.navWrapper} key={i}>
               <NavContainer
                title={item.name}
                icon={
                  (window.location.pathname.includes(item.link) || (hovered === i))
                    ? item.activeIcon
                    : item.icon
                }
                active={window.location.pathname.includes(item.link) || (hovered === i)}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => {
                  if (item.link === "profile") {
                    setShowCardNav(!showCardNav);
                  } else {
                    setShowCardNav(false);
                    navigate(item.link);
                  }
                }}
              />
            </div>
          ))}
        </div>
      </div>
      {/* <div className={classes.settingsWrapper}>
        <div className={`d-flex flex-column justify-content-center align-items-center ${classes.settingsButton}`} role="button" onClick={() => setShowCardNav(!showCardNav)}>
          <GearIcon /> 
         
        </div>

        {showCardNav && <div
                  className={`${classes.sideNavCard} d-flex flex-column justify-content-between`}
                >
                  {subNav.map((item, i) => (
                    <div
                      className={`${classes.subNavText} ${item.link === "login" ? classes.logOutText : ""}`}
                      key={i}
                      onClick={() => {
                        if(item.link !== "theme"){
                          if(item.link === "login"){
                            logout()
                          }else{
                            navigate(item.link);
                          }
                          setShowCardNav(false);
                        }
                        
                      }}
                      role="button"
                    >
                      <div className="d-flex  align-items-center gap-3">
                      {item.name}{item.link === "theme" && <Switcher
                  handleIcon={
                    darkMode ? (
                      <MoonIcon color="#111111" small={true} />
                    ) : (
                      <SunIcon color="white" size={18} />
                    )
                  }
                  activeValue={<SunIcon size={18} color="#B3B3B3" />}
                  inactiveValue={<MoonIcon small={true} />}
                  value={darkMode}
                  onChange={toggleDarkMode}
                />}
                </div>
                    </div>
                  ))}
                </div>}
      </div> */}
    </div>
  );
};

export default SideBar;
